import LeftNav from "./LeftNav";
import TopNav from "./TopNav";
import {
    makeStyles, shorthands
} from "@fluentui/react-components";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
// The publishable key comes from the environment, never a literal.
//
// A hardcoded pk_test_ key used to live here, which meant the PRODUCTION portal
// initialised Stripe in TEST mode. createToken happily returned a test-mode
// token, the backend then presented that token with the LIVE secret key, and
// Stripe rejected it — so every card staff tried to add from the portal failed,
// in an environment that looked correctly configured.
//
// Keep this reading the env var. CRA inlines REACT_APP_* at build time, and the
// pipeline supplies it per environment from the Azure DevOps variable groups
// (WH_WEB_DEV_* / WH_WEB_PROD_*), which is the only place the live/test split
// should be expressed.
const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Deliberately not fatal: this provider wraps the entire portal, so throwing
// here would white-screen member management, events and billing over a missing
// card-entry key. Instead Stripe stays uninitialised, the card form reports it
// (see UserWalletForm), and the build logs loudly enough to be caught in the
// pipeline output.
if (!STRIPE_PUBLISHABLE_KEY) {
    console.error(
        "REACT_APP_STRIPE_PUBLISHABLE_KEY is not set. Stripe is not initialised " +
        "and card entry will be unavailable. Set it in the deployment variable " +
        "group for this environment."
    );
}

const stripePromise = STRIPE_PUBLISHABLE_KEY ? loadStripe(STRIPE_PUBLISHABLE_KEY) : null;

const useStyles = makeStyles({
    root: {
        backgroundColor: "#fff",

        display: 'grid',
        gridTemplateAreas: `
        "header header header header header header"
        "menu main main main main main"
        `
    },
    contentcontainer: {
    },
    childLayout:{
        height: "calc(100vh - 48px)",
        overflow: "auto !important"
    }
});

function Layout({ children }) {
    const styles = useStyles();
    return (
        <div className={styles.root}>
            <TopNav></TopNav>
            <LeftNav></LeftNav>
            {/* {children} */}
            <div style={{ height: "calc(100vh - 48px)", overflow: "auto" }}>
                <Elements stripe={stripePromise}>{children}</Elements>
            </div>
        </div>)
}

export default Layout;